import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import CareerConnectorSection from '../components/sections/CareerConnector'

const CareerConnector = () => {
  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio'>
            <CareerConnectorSection />
            <Footer />
          </div>
        </div>
      </div>
      <Header />
    </>
  )
}

export default CareerConnector
